import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-perical-results-grid',
  template: `
    <app-ng-table-results
      class="flex-1 min-h-0 block"
      [tableName]="tableName"
      [tableData]="tableData ?? []"
      [columnDefinitions]="columnDefinitions ?? []"
      [selectedOperation]="selectedOperation"
      [minTemp]="minTemp"
      [maxTemp]="maxTemp"
      [showHeatmap]="showHeatmap"
      [virtualScroll]="virtualScroll"
      [tableHeight]="'flex'"
      [autoHeight]="false"
    />
  `,
  styles: [':host { display: flex; flex-direction: column; height: 100%; min-height: 0; overflow: hidden; } :host([hidden]) { display: none !important; }'],
  standalone: false
})
export class PericalResultsGridComponent {
  @Input()
  public tableName!: string;

  @Input()
  public tableData!: any[];

  @Input()
  public columnDefinitions!: any[];

  @Input()
  public selectedOperation: any;

  @Input()
  public virtualScroll: boolean | string = true;

  @Input()
  public minTemp: number | null = null;

  @Input()
  public maxTemp: number | null = null;

  @Input()
  public showHeatmap = false;
}
